import React, { useEffect, useState, useCallback } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { CheckBox } from "../FormularioJSON/CheckRow/styles";
import SelectDinamico from "../SelectDinamico";
import ConsultaCentroCusto from "../../../lib/json/consultas/CentroCustoSSMA.json";

const EmpresaPane = React.memo(({
  cEmpresa,
  selecoes,
  campoCentroCusto,
  handleCheckboxChange,
  handleChangeSelect,
  handleCentroCustoChange,
}) => {
  const cIncSC = cEmpresa + "incluirSolicitacao";
  const cVisSC = cEmpresa + "visualizarSolicitacao";
  const cVisPC = cEmpresa + "visualizarPedidoCompra";
  const cAvalSSMA = cEmpresa + "avaliarSSMA";

  return (
	<Tab.Pane eventKey={cEmpresa}>
	  <Row>
		<Col md="12">
		  <SelectDinamico
			label="Centro de Custo"
			consulta={ConsultaCentroCusto.consulta + ` WHERE CTT_FILIAL = '${cEmpresa.substring(2,4)}01'`}
			tabela={ConsultaCentroCusto.tabelas}
			cValue="CTT_CUSTO"
			cText='CTT_CUSTO + " - " + item.CTT_DESC01'
			isMultiplo={true}
			EmpresaLogada={cEmpresa}
			campoValue={campoCentroCusto[cEmpresa] || ''}
			value={campoCentroCusto[cEmpresa] || ''}
			onchange={(e) => handleChangeSelect(e, cEmpresa)}
			onblur={handleCentroCustoChange}
		  />
		</Col>
	  </Row>
	  <Row>
		<Col md="4">
		  <CheckBox
		  	tabIndex={-1}
			id={cVisSC}
			type="checkbox"
			label="Visualizar Solicitação de Outros"
			checked={selecoes[cVisSC] || false}
			onChange={(e) => handleCheckboxChange(cEmpresa, e.target)}
		  />
		</Col>
		<Col md="4">
		  <CheckBox
		  	tabIndex={-1}
			id={cIncSC}
			type="checkbox"
			label="Incluir Solicitação de Compras para Outros"
			checked={selecoes[cIncSC] || false}
			onChange={(e) => handleCheckboxChange(cEmpresa, e.target)}
		  />
		</Col>
		<Col md="4">
		  <CheckBox
		  	tabIndex={-1}
			id={cVisPC}
			type="checkbox"
			label="Visualizar Pedido de Compras de Outros"
			checked={selecoes[cVisPC] || false}
			onChange={(e) => handleCheckboxChange(cEmpresa, e.target)}
		  />
		</Col>
		<Col md="4">
		  <CheckBox
		  	tabIndex={-1}
			id={cAvalSSMA}
			type="checkbox"
			label="Habilita Avaliação de SSMA"
			checked={selecoes[cAvalSSMA] || false}
			onChange={(e) => handleCheckboxChange(cEmpresa, e.target)}
		  />
		</Col>
	  </Row>
	</Tab.Pane>
  );
});

function ConfiguracaoEmpresa({ empresas, preencheValue, selecionados, onSelectionChange, centroCustoSelecionados }) {
  const [selecoes, setSelecoes] = useState(selecionados);
  const [campoCentroCusto, setCampoCentroCusto] = useState(centroCustoSelecionados);

  useEffect(() => {
	setSelecoes(selecionados);
  }, [selecionados]);

  useEffect(() => {
	setCampoCentroCusto(centroCustoSelecionados);
  }, [centroCustoSelecionados]);

  const uniqueSet = new Set();

  const empresasParametros = empresas.map(item => {
	const [code, empresa, filial] = item.split(' - ');
	const mainCode = code.substring(0, 4);

	if (!uniqueSet.has(mainCode)) {
	  uniqueSet.add(mainCode);
	  return mainCode + ' - ' + empresa;
	}
	return null;
  }).filter(item => item !== null);

  // Funções memoizadas para evitar rerenders
  const handleCheckboxChange = useCallback((item, itemSelect) => {
	// Ignora se for evento programático ou focado por tab
  	if (document.activeElement !== itemSelect) return;

	setSelecoes(prev => ({
	  ...prev,
	  [itemSelect.id]: itemSelect.checked,
	}));
	preencheValue(item, itemSelect.checked, itemSelect.id);
  }, [preencheValue]);

  const handleChangeSelect = useCallback(async (e, idEmpresa) => {
	setCampoCentroCusto(prev => ({
	  ...prev,
	  [idEmpresa]: e,
	}));
  }, []);

  const handleCentroCustoChange = useCallback(() => {
	onSelectionChange(campoCentroCusto);
  }, [campoCentroCusto, onSelectionChange]);

  return (
	<Row>
	  <Tab.Container defaultActiveKey={empresasParametros[0]?.split("-")[0].trim()} mountOnEnter>
		<Nav variant="tabs">
		  {empresasParametros.map((empresa) => {
			const cEmpresa = empresa.split("-")[0].trim();
			return (
			  <Nav.Item key={cEmpresa}>
				<Nav.Link eventKey={cEmpresa}>{empresa}</Nav.Link>
			  </Nav.Item>
			);
		  })}
		</Nav>
		<Tab.Content>
		  {empresasParametros.map((empresa) => {
			const cEmpresa = empresa.split("-")[0].trim();
			return (
			  <EmpresaPane
				key={cEmpresa}
				cEmpresa={cEmpresa}
				selecoes={selecoes}
				campoCentroCusto={campoCentroCusto}
				handleCheckboxChange={handleCheckboxChange}
				handleChangeSelect={handleChangeSelect}
				handleCentroCustoChange={handleCentroCustoChange}
			  />
			);
		  })}
		</Tab.Content>
	  </Tab.Container>
	</Row>
  );
}

export default ConfiguracaoEmpresa;
